import Input, { BaseInputPropsType } from "./Input";

type UsernameInputPropsType = BaseInputPropsType<HTMLInputElement, string> & {
    minLength?: number
    maxLength?: number,
}

const UsernameInput = (props: UsernameInputPropsType) => {
    return <Input {...props} type="username" pattern="[a-z]+[a-z0-9._-]+" />
};

export default UsernameInput;
